import React, { useEffect } from 'react';

export default function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-32 pb-20 bg-slate-50 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-[2rem] p-8 md:p-12 shadow-sm border border-slate-100">
          <h1 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-8">Terms & Conditions</h1>
          
          <div className="space-y-6 text-slate-600 leading-relaxed">
            <p>Last updated: {new Date().toLocaleDateString()}</p>
            
            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing and using the RenewRX website and services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by these terms, please do not use our service.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">2. Description of Service</h2>
            <p>
              RenewRX provides a platform connecting patients with licensed healthcare professionals for telehealth consultations and the potential prescription of medical treatments. We are not a pharmacy or a medical provider ourselves, but facilitate these services through third-party partners.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">3. User Responsibilities</h2>
            <p>
              You agree to provide accurate, current, and complete information during the intake process and telehealth consultations. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">4. Limitations of Liability</h2>
            <p>
              RenewRX shall not be liable for any direct, indirect, incidental, special, or consequential damages resulting from the use or inability to use our services, or for the cost of procurement of substitute services.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">5. Modifications to Service</h2>
            <p>
              RenewRX reserves the right to modify or discontinue, temporarily or permanently, the service with or without notice to the user. We shall not be liable to you or any third party for any modification, suspension, or discontinuance of the service.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}